import React, { useState } from "react";
import { withBreakpoints } from "react-breakpoints";

import Card from "./Card";
import Filter from "./Filter";
import theme, {
  navbarHeight,
  styles as commonStyles,
} from "../../../utils/styles";
import { randomColors } from "../../../utils/helpers";

import data from "../../../data/videos";

const randomColorsList = randomColors(100);

const Videos = (props) => {
  const { breakpoints, currentBreakpoint } = props;
  const isBreakpoint = breakpoints[currentBreakpoint] < breakpoints.desktop;

  let listOfAllTags = [];

  data.forEach((video) => listOfAllTags.push(...video.tags));

  listOfAllTags = [...new Set(listOfAllTags)];
  listOfAllTags = listOfAllTags.sort((a, b) => b.length - a.length);

  listOfAllTags.forEach(
    (tag, index) =>
      (listOfAllTags[index] = {
        tag,
        color: randomColorsList[index],
      })
  );

  const [filterNames, setFilterName] = useState([]);

  // console.log(filterNames);

  const renderCards = data.map((video, index) => {
    const { tags } = video;

    let matchedWithFilter;

    for (let i = 0; i < filterNames.length; i++) {
      const filter = filterNames[i];
      if (tags.indexOf(filter) > -1) {
        matchedWithFilter = true;
        break;
      }
    }

    const noFilter = filterNames.length === 0;

    return noFilter || matchedWithFilter ? (
      <div key={index}>
        <Card video={video} index={index} listOfAllTags={listOfAllTags} />
      </div>
    ) : null;
  });

  return (
    <div style={styles.root}>
      <div style={styles.container}>
        <div style={styles.heading}>Videos</div>
        <div style={{ ...styles.filterContainer }}>
          <Filter
            listOfAllTags={listOfAllTags}
            setFilterName={setFilterName}
            isBreakpoint={isBreakpoint}
          />
        </div>
        <div style={styles.grid}>{renderCards}</div>
      </div>
    </div>
  );
};

export default withBreakpoints(Videos);

const { spacing } = commonStyles.videos();

const styles = {
  root: {
    background: theme.colors.background,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    minHeight: "100vh",
  },
  container: {
    marginTop: navbarHeight * 2,
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    rowGap: spacing * 2,
    // background: "blue",
  },
  heading: {
    color: "white",
    fontSize: "25px",
    fontWeight: "bold",
    width: "100%",
    // background: "red",
  },
  filterContainer: {
    width: "100%",
    // background: "yellow",
  },
  grid: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
    columnGap: spacing,
    rowGap: spacing,
    // background: "red",
    borderStyle: "none none solid none",
    borderWidth: spacing * 2,
    borderColor: "#00000000",
  },
};
